module.exports = __webpack_public_path__ + "static/media/Agregar.2a689bb4.svg";